<template>
  <div class="animated fadeIn">
    <template>
      <CCard>
        <CRow class="mt-4">
          <CCol sm="1"></CCol>
          <CCol sm="3">
            <v-select
              horizontal
              v-model="SelectedUser"
              :options="[
                { label: 'Students', id: 1 },
                { label: 'Parents', id: 2 },
              ]"
              placeholder="Select Users"
            />
          </CCol>
          <CCol sm="6">
            <div v-if="SelectedUser.id == 1">
              <v-select
                v-model="SelectedStudent"
                :options="students"
                style="width: 100%; position: relative; z-index: auto"
                label="Name"
                placeholder="Please Select Student Name"
                required
              ></v-select>
            </div>
            <div v-if="SelectedUser.id == 2">
              <v-select
                v-model="SelectedParent"
                :options="parents"
                style="width: 100%; position: relative; z-index: auto"
                label="Name"
                placeholder="Please Select Parent Name"
                required
              ></v-select>
            </div>
            <div v-if="SelectedUser.id == 3">
              <v-select
                v-model="SelectedTeacher"
                :options="teachers"
                style="width: 100%; position: relative; z-index: auto"
                label="Name"
                placeholder="Please Select Teacher Name"
                required
              ></v-select>
            </div>
          </CCol>
          <CCol sm="1">
            <CButton class="custom-btn-light" size="sm" @click="RefreshData()">
              <div>
                <CIcon name="cilSync" />
              </div>
            </CButton>
          </CCol>
          <CCol sm="1"></CCol>
        </CRow>
        <br />
        <!-- <CRow>
          <CCol sm="1"></CCol>
          <CCol sm="10">
            <CInput type="text" placeholder="Search"></CInput>
          </CCol>
          <CCol sm="1"></CCol>
        </CRow> -->
        <!-- <hr />
        <CRow>
          <CCol sm="1" class="mt-1"></CCol>
          <CCol sm="10" class="mt-1">
            <CTextarea
              id="basicTextarea"
              :rows="2"
              class="mt-1"
              placeholder="Search by specific data"
            ></CTextarea>
          </CCol>
          <CCol sm="1" class="mt-1 d-flex justify-content-end">
            <CButton
              v-b-tooltip.hover
              :title="LastRefresh | moment('D MMM YYYY, hh:mm A')"
              variant="outline-default"
              @click="RefreshDataIcNumber()"
            >
              <i class="fa fa-refresh"></i>
            </CButton>
          </CCol>
        </CRow> -->
      </CCard>
      <template v-if="SelectedUser.id == 1">
        <CCard>
          <br />
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <div>
                  <span class="small text-muted"
                    >Name :&nbsp;</span
                  >
                  {{ studentDetails.Name }}
                </div>
                <!-- <div class="text-muted">
                  <span class="small text-muted">Student ID :&nbsp;</span>
                  {{ studentDetails.Id }}
                </div> -->
                <div class="text-muted">
                  <span class="small text-muted"
                    >Email Student :&nbsp;</span
                  >
                  {{ studentDetails.StudentEmail }}
                </div>
                <div class="text-muted">
                  <span class="small text-muted"
                    >Status :&nbsp;</span
                  >
                  <CBadge color="info">{{ studentDetails.Status }}</CBadge>
                </div>
              </CCol>
              <CCol sm="6">
                <div class="text-muted">
                  <span class="small text-muted"
                    >Email Parent :&nbsp;</span
                  >
                  {{ studentDetails.ParentEmail }}
                </div>
                <div class="text-muted">
                  <span class="small text-muted"
                    >Parent Phone Number :&nbsp;</span
                  >
                  {{ studentDetails.parentPhoneNumber }}
                </div>
                <div class="text-muted">
                  <span class="small text-muted"
                    >Grade :&nbsp;</span
                  >
                  {{ studentDetails.Grade }}
                </div>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Attendance">
                <br />
                <CCard body-wrapper sm="12">
                  <CCol sm="12">
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="studentDetails.StudentAttendances"
                      :fields="fields"
                      items-per-page-select
                      :items-per-page="small ? 5 : 10"
                      :dark="dark"
                      sorter
                      pagination
                    >
                      <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template #ScheduleDateTime="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.ScheduleDateTime | moment("DD MMM YYYY")
                          }}</CBadge>
                        </td>
                      </template>
                      <template #Action="{ item }">
                        <td style="white-space: nowrap">
                          <CButton
                            title="Set Payment"
                            type="button"
                            class="custom-btn-light"
                            @click="GotoAttendancePage(item)"
                          >
                            <CIcon name="cilPencil"
                          /></CButton>
                        </td>
                      </template>
                      <template #ClassInfo="{ item }">
                        <td>
                          <div>
                            <span class="custom-small text-muted"> Class Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.ClassName }}</span>
                          </div>
                          <div>
                          <span class="custom-small text-muted"> Teacher Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.TeacherName }}</span>
                            Teacher Name : {{ item.TeacherName }}
                          </div>
                        </td>
                      </template>
                    </CDataTable>
                    <!-- <table
                    class="
                      table table-responsive-sm table-hover table-outline
                      mb-0
                    "
                  >
                    <thead class="thead-light">
                      <tr>
                        <th></th>
                        <th>Subject</th>
                        <th>Class</th>
                        <th>Teacher</th>
                        <th>Date</th>
                        <th>Attendance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          item, index
                        ) in studentDetails.StudentAttendances"
                        v-bind:key="item.Id"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.SubjectName }}</td>
                        <td>{{ item.ClassName }}</td>
                        <td>{{ item.TeacherName }}</td>
                        <td>{{ item.ScheduleDateTime | moment("DD MM YYYY") }}</td>
                        <td>
                          <CButton
                            type="button"
                            color="success"
                            style="
                              background: linear-gradient(
                                135deg,
                                #3a416f 0%,
                                #141727 100%
                              );
                              box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.12),
                                0px 2px 4px -1px rgba(0, 0, 0, 0.12);
                            "
                            @click="InsertReload()"
                            >Set Attend</CButton
                          >
                          <CButton
                            type="button"
                            color="danger"
                            style="
                              margin-left: 4px;
                              background: linear-gradient(
                                135deg,
                                #3a416f 0%,
                                #141727 100%
                              );
                              box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.12),
                                0px 2px 4px -1px rgba(0, 0, 0, 0.12);
                            "
                            @click="InsertReload()"
                            >Set Not Attend</CButton
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table> -->
                  </CCol>
                </CCard>
              </CTab>
              <CTab title="Payment">
                <br />
                <CCard body-wrapper sm="12">
                  <CDataTable
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    :items="studentDetails.StudentPayments"
                    :fields="paymentstudent"
                    items-per-page-select
                    :items-per-page="small ? 5 : 10"
                    :dark="dark"
                    :index="index"
                    responsive="true"
                    sorter
                    pagination
                  >
                    <template #No="{ index }">
                      <td>
                        <div class="text-uppercase font-weight-bold">
                          {{ index + 1 }}
                        </div>
                      </td>
                    </template>
                    <template #PaymentInfo="{ item }">
                      <td>
                        <h6 style="color: #1e109c" class="text-uppercase">
                          {{ item.Month }}
                        </h6>
                        <div>
                          <span class="custom-small text-muted"> Additional Payment :</span> <span class="custom-small-overview custom-text-overview">{{ item.AdditionalPayment }}</span>
                        </div>
                        <div>
                         <span class="custom-small text-muted"> Payment Amount :</span> <span class="custom-small-overview custom-text-overview">{{ item.PaymentAmount }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Payment Method :</span> <span class="custom-small-overview custom-text-overview">{{ item.PaymentMethod }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Is Paid :</span> <span class="custom-small-overview custom-text-overview">{{ item.IsPaid }}</span>
                        </div>
                      </td>
                    </template>
                    <template #ParentPaymentTime="{ item }">
                      <td>
                        <CBadge color="success" class="ml-auto">{{
                          item.ParentPaymentTime | moment("DD MMM YYYY")
                        }}</CBadge>
                      </td>
                    </template>
                    <template #Action="{ item }">
                      <td style="white-space: nowrap">
                        <CButton
                          title="Set Payment"
                          type="button"
                          class="custom-btn-light"
                          @click="GotoPaymentPage(item)"
                        >
                          <CIcon name="cilPencil"
                        /></CButton>
                      </td>
                    </template>
                    <template #InvoiceInfo="{ item }">
                      <td>
                        <div>
                          <span class="custom-small text-muted"> Tuition Invoice Id :</span> <span class="custom-small-overview custom-text-overview">{{ item.TuitionInvoiceID }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Invoice :</span> <span class="custom-small-overview custom-text-overview">{{ item.Invoice }}</span>
                        </div>
                      </td>
                    </template>
                  </CDataTable>
                </CCard>
              </CTab>
              <CTab title="Parent">
                <br />
                <CCard body-wrapper sm="12">
                  <CRow>
                    <CCol sm="6">
                      <CCardBody>
                        <CForm>
                          <CInput
                            label="Student Name"
                            v-model="studentDetails.Name"
                            horizontal
                            autocomplete="name"
                          />
                          <CInput
                            label="Student Class"
                            v-model="studentDetails.Class"
                            horizontal
                            autocomplete="studentClass"
                          />
                          <CInput
                            label="Parent Email"
                            v-model="studentDetails.ParentEmail"
                            horizontal
                            autocomplete="parentEmail"
                          />
                          <CInput
                            label="Parent Phone Number"
                            v-model="studentDetails.ParentPhoneNumber"
                            horizontal
                            autocomplete="parentPhoneNumber"
                          />
                          <CInput
                            label="Class"
                            v-model="studentDetails.Class"
                            horizontal
                            autocomplete="class"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Birth Date"
                            v-model="item.BirthDate"
                            horizontal
                            autocomplete="birthDate"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Age"
                            v-model="item.Age"
                            horizontal
                            autocomplete="age"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Main Contact"
                            v-model="item.MainContactNumber"
                            horizontal
                            autocomplete="mainContact"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Occupation"
                            v-model="item.Occupation"
                            horizontal
                            autocomplete="occupation"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="State"
                            v-model="item.State"
                            horizontal
                            autocomplete="state"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Father Phone Number"
                            v-model="item.FatherPhoneNumber"
                            horizontal
                            autocomplete="fatherPhoneNumber"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Package Interest"
                            v-model="item.PackageInterest"
                            horizontal
                            autocomplete="package"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Allergy"
                            v-model="item.FoodAllergy"
                            horizontal
                            autocomplete="allergy"
                          />
                        </CForm>
                      </CCardBody>
                    </CCol>
                    <CCol sm="6">
                      <CCardBody>
                        <CForm>
                          <CInput
                            label="Student Grade"
                            v-model="studentDetails.Grade"
                            horizontal
                            autocomplete="studentGrade"
                          />
                          <CInput
                            label="Parent Name"
                            v-model="studentDetails.ParentName"
                            horizontal
                            autocomplete="parentName"
                          />
                          <CInput
                            label="Status"
                            v-model="studentDetails.Status"
                            horizontal
                            autocomplete="status"
                          />
                          <CInput
                            label="Grade"
                            v-model="studentDetails.Grade"
                            horizontal
                            autocomplete="grade"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="IC Number"
                            v-model="item.IdentityCertificateNumber"
                            horizontal
                            autocomplete="icNumber"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Gender"
                            v-model="item.Gender"
                            horizontal
                            autocomplete="gender"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Facebook"
                            v-model="item.Facebook"
                            horizontal
                            autocomplete="facebook"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Zip Code"
                            v-model="item.ZipCode"
                            horizontal
                            autocomplete="zipCode"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Home Phone Number"
                            v-model="item.HomePhoneNumber"
                            horizontal
                            autocomplete="homePhoneNumber"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Mother Phone Number"
                            v-model="item.MotherPhoneNumber"
                            horizontal
                            autocomplete="motherPhoneNumber"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="Remark"
                            v-model="item.Remarks"
                            horizontal
                            autocomplete="remark"
                          />
                          <CInput
                            v-for="item in studentDetails.StudentRegInfo"
                            v-bind:key="item.Id"
                            label="School Name"
                            v-model="item.SchoolName"
                            horizontal
                            autocomplete="schoolName"
                          />
                        </CForm>
                      </CCardBody>
                    </CCol>
                  </CRow>
                </CCard>
              </CTab>
              <CTab title="Quiz">
                <br />
                <CCard body-wrapper sm="12">
                  <CCol sm="12" lg="12">
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="studentDetails.StudentQuiz"
                      :fields="quiz"
                      items-per-page-select
                      :items-per-page="small ? 5 : 10"
                      :dark="dark"
                      sorter
                      pagination
                    >
                      <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template #CreateTime="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.CreateTime | moment("DD MMM YYYY")
                          }}</CBadge>
                        </td>
                      </template>
                      <template #QuizInfo="{ item }">
                        <td>
                          <div>
                            <span class="custom-small text-muted"> Quiz Title :</span> <span class="custom-small-overview custom-text-overview">{{ item.QuizTitle }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Quiz Score :</span> <span class="custom-small-overview custom-text-overview">{{ item.QuizScore }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Quiz Percentage :</span> <span class="custom-small-overview custom-text-overview">{{ item.QuizPercentage }}</span>
                          </div>
                        </td>
                      </template>
                    </CDataTable>
                  </CCol>
                </CCard>
              </CTab>
              <CTab title="Schedule">
                <br />
                <CCard body-wrapper sm="12">
                  <!-- <CCard style="height: 280px" class="box-shadow-dashboard">
                  <calendar
                    :eventCategories="eventCategories"
                    ref="calendar"
                    @click-event="onClickItem"
                  />
                </CCard> -->
                  <CCol sm="12">
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="studentDetails.StudentSchedule"
                      :fields="scheduleStudent"
                      items-per-page-select
                      :items-per-page="small ? 5 : 10"
                      :dark="dark"
                      responsive="true"
                      sorter
                      pagination
                    >
                      <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template #StudentInfo="{ item }">
                        <td>
                          <h6 style="color: #1e109c" class="text-uppercase">
                            {{ item.SubjectName }}
                          </h6>
                          <div>
                            <span class="custom-small text-muted"> Description :</span> <span class="custom-small-overview custom-text-overview">{{ item.Description }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Grade :</span> <span class="custom-small-overview custom-text-overview">{{ item.Grade }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Class Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.ClassName }}</span>
                          </div>
                        </td>
                      </template>
                      <template #Start="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.Start | moment("DD MMM YYYY HH:mm:ss")
                          }}</CBadge>
                        </td>
                      </template>
                      <template #End="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.End | moment("DD MMM YYYY HH:mm:ss")
                          }}</CBadge>
                        </td>
                      </template>
                    </CDataTable>
                    <!-- <vue-cal
                    class="vuecal--white-theme"
                    :events="feedData"
                    :time-from="7 * 60"
                    events-count-on-year-view="events-count-on-year-view"
                    events-on-month-view="short"
                    active-view="month"
                  >
                    <template v-slot:no-event="">No event 👌</template>
                  </vue-cal> -->
                  </CCol>
                </CCard>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </template>
      <template v-if="SelectedUser.id == 2">
        <CCard
          class
          v-for="item in detailByParent.StudentDetail"
          v-bind:key="item.Id"
        >
          <br />
          <CCardHeader>
            <CRow>
              <CCol sm="6">
                <div>
                  <span class="small text-muted"
                    >Name :&nbsp;</span
                  >
                  {{ item.Name }}
                </div>
                <!-- <div class="text-muted">
                  <span class="small text-muted">Student ID :&nbsp;</span>
                  {{ item.Id }}
                </div> -->
                <div class="text-muted">
                  <span class="small text-muted"
                    >Email Student :&nbsp;</span
                  >
                  {{ item.StudentEmail }}
                </div>
                <div class="text-muted">
                  <span class="small text-muted"
                    >Status :&nbsp;</span
                  >
                  <CBadge color="info">{{ item.Status }}</CBadge>
                </div>
              </CCol>
              <CCol sm="6">
                <div class="text-muted">
                  <span class="small text-muted"
                    >Email Parent :&nbsp;</span
                  >
                  {{ item.ParentEmail }}
                </div>
                <div class="text-muted">
                  <span class="small text-muted"
                    >Parent Phone Number :&nbsp;</span
                  >
                  {{ item.parentPhoneNumber }}
                </div>
                <div class="text-muted">
                  <span class="small text-muted"
                    >Grade :&nbsp;</span
                  >
                  {{ item.Grade }}
                </div>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CTabs>
              <CTab title="Attendance">
                <br />
                <CCard body-wrapper sm="12">
                  <CCol sm="12">
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="item.StudentAttendances"
                      :fields="fields"
                      items-per-page-select
                      :items-per-page="small ? 5 : 10"
                      :dark="dark"
                      sorter
                      pagination
                    >
                      <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template #ScheduleDateTime="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.ScheduleDateTime | moment("DD MMM YYYY")
                          }}</CBadge>
                        </td>
                      </template>
                      <template #Action="{ item }">
                        <td style="white-space: nowrap">
                          <CButton
                            title="Set Payment"
                            type="button"
                            class="custom-btn-light"
                            @click="GotoAttendancePageByParent(item)"
                          >
                            <CIcon name="cilPencil"
                          /></CButton>
                        </td>
                      </template>
                      <template #ClassInfo="{ item }">
                        <td>
                          <div>
                            <span class="custom-small text-muted"> Class Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.ClassName }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Teacher Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.TeacherName }}</span>
                          </div>
                        </td>
                      </template>
                    </CDataTable>
                  </CCol>
                </CCard>
              </CTab>
              <CTab title="Payment">
                <br />
                <CCard body-wrapper sm="12">
                  <CDataTable
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :fixed="fixed"
                    :items="item.StudentPayments"
                    :fields="paymentstudent"
                    items-per-page-select
                    :items-per-page="small ? 5 : 10"
                    :dark="dark"
                    sorter
                    pagination
                  >
                    <template #No="{ index }">
                      <td>
                        <div class="text-uppercase font-weight-bold">
                          {{ index + 1 }}
                        </div>
                      </td>
                    </template>
                    <template #PaymentInfo="{ item }">
                      <td>
                        <h6 style="color: #1e109c" class="text-uppercase">
                          {{ item.Month }}
                        </h6>
                        <div>
                          <span class="custom-small text-muted"> Additional Payment :</span> <span class="custom-small-overview custom-text-overview">{{ item.AdditionalPayment }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Payment Amount :</span> <span class="custom-small-overview custom-text-overview">{{ item.PaymentAmount }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Payment Method :</span> <span class="custom-small-overview custom-text-overview">{{ item.PaymentMethod }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Is Paid :</span> <span class="custom-small-overview custom-text-overview">{{ item.IsPaid }}</span>
                        </div>
                      </td>
                    </template>
                    <template #ParentPaymentTime="{ item }">
                      <td>
                        <CBadge color="success" class="ml-auto">{{
                          item.ParentPaymentTime | moment("DD MMM YYYY")
                        }}</CBadge>
                      </td>
                    </template>
                    <template #Action="{ item }">
                      <td style="white-space: nowrap">
                        <CButton
                          title="Set Payment"
                          type="button"
                          class="custom-btn-light"
                          @click="GotoPaymentPageByParent(item)"
                        >
                          <CIcon name="cilPencil"
                        /></CButton>
                      </td>
                    </template>
                    <template #InvoiceInfo="{ item }">
                      <td>
                        <div>
                          <span class="custom-small text-muted"> Tuition Invoice ID :</span> <span class="custom-small-overview custom-text-overview">{{ item.TuitionInvoiceID }}</span>
                        </div>
                        <div>
                          <span class="custom-small text-muted"> Invoice :</span> <span class="custom-small-overview custom-text-overview">{{ item.Invoice }}</span>
                        </div>
                      </td>
                    </template>
                  </CDataTable>
                </CCard>
              </CTab>
              <CTab title="Parent">
                <br />
                <CCard body-wrapper sm="12">
                  <CRow>
                    <CCol sm="6">
                      <CCardBody>
                        <CForm>
                          <CInput
                            label="Student Name"
                            v-model="item.Name"
                            horizontal
                            autocomplete="name"
                          />
                          <CInput
                            label="Student Class"
                            v-model="item.Class"
                            horizontal
                            autocomplete="studentClass"
                          />
                          <CInput
                            label="Parent Email"
                            v-model="item.ParentEmail"
                            horizontal
                            autocomplete="parentEmail"
                          />
                          <CInput
                            label="Parent Phone Number"
                            v-model="item.ParentPhoneNumber"
                            horizontal
                            autocomplete="parentPhoneNumber"
                          />
                          <CInput
                            label="Class"
                            v-model="item.Class"
                            horizontal
                            autocomplete="class"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Birth Date"
                            v-model="dtl.BirthDate"
                            horizontal
                            autocomplete="birthDate"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Age"
                            v-model="dtl.Age"
                            horizontal
                            autocomplete="age"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Main Contact"
                            v-model="dtl.MainContactNumber"
                            horizontal
                            autocomplete="mainContact"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Occupation"
                            v-model="dtl.Occupation"
                            horizontal
                            autocomplete="occupation"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="State"
                            v-model="dtl.State"
                            horizontal
                            autocomplete="state"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Father Phone Number"
                            v-model="dtl.FatherPhoneNumber"
                            horizontal
                            autocomplete="fatherPhoneNumber"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Package Interest"
                            v-model="dtl.PackageInterest"
                            horizontal
                            autocomplete="package"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Allergy"
                            v-model="dtl.FoodAllergy"
                            horizontal
                            autocomplete="allergy"
                          />
                        </CForm>
                      </CCardBody>
                    </CCol>
                    <CCol sm="6">
                      <CCardBody>
                        <CForm>
                          <CInput
                            label="Student Grade"
                            v-model="item.Grade"
                            horizontal
                            autocomplete="studentGrade"
                          />
                          <CInput
                            label="Parent Name"
                            v-model="item.ParentName"
                            horizontal
                            autocomplete="parentName"
                          />
                          <CInput
                            label="Status"
                            v-model="item.Status"
                            horizontal
                            autocomplete="status"
                          />
                          <CInput
                            label="Grade"
                            v-model="item.Grade"
                            horizontal
                            autocomplete="grade"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="IC Number"
                            v-model="dtl.IdentityCertificateNumber"
                            horizontal
                            autocomplete="icNumber"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Gender"
                            v-model="dtl.Gender"
                            horizontal
                            autocomplete="gender"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Facebook"
                            v-model="dtl.Facebook"
                            horizontal
                            autocomplete="facebook"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Zip Code"
                            v-model="dtl.ZipCode"
                            horizontal
                            autocomplete="zipCode"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Home Phone Number"
                            v-model="dtl.HomePhoneNumber"
                            horizontal
                            autocomplete="homePhoneNumber"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Mother Phone Number"
                            v-model="dtl.MotherPhoneNumber"
                            horizontal
                            autocomplete="motherPhoneNumber"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="Remark"
                            v-model="dtl.Remarks"
                            horizontal
                            autocomplete="remark"
                          />
                          <CInput
                            v-for="dtl in item.StudentRegInfo"
                            v-bind:key="dtl.Id"
                            label="School Name"
                            v-model="dtl.SchoolName"
                            horizontal
                            autocomplete="schoolName"
                          />
                        </CForm>
                      </CCardBody>
                    </CCol>
                  </CRow>
                </CCard>
              </CTab>
              <CTab title="Quiz">
                <br />
                <CCard body-wrapper sm="12">
                  <CCol sm="12" lg="12">
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="item.StudentQuiz"
                      :fields="quiz"
                      items-per-page-select
                      :items-per-page="small ? 5 : 10"
                      :dark="dark"
                      sorter
                      pagination
                    >
                      <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template #CreateTime="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.CreateTime | moment("DD MMM YYYY")
                          }}</CBadge>
                        </td>
                      </template>
                      <template #QuizInfo="{ item }">
                        <td>
                          <div>
                            <span class="custom-small text-muted"> Quiz Title :</span> <span class="custom-small-overview custom-text-overview">{{ item.QuizTitle }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Quiz Score :</span> <span class="custom-small-overview custom-text-overview">{{ item.QuizScore }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Quiz Percentage :</span> <span class="custom-small-overview custom-text-overview">{{ item.QuizPercentage }}</span>
                          </div>
                        </td>
                      </template>
                    </CDataTable>
                  </CCol>
                </CCard>
              </CTab>
              <CTab title="Schedule">
                <br />
                <CCard body-wrapper sm="12">
                  <!-- <CCard style="height: 280px" class="box-shadow-dashboard">
                  <calendar
                    :eventCategories="eventCategories"
                    ref="calendar"
                    @click-event="onClickItem"
                  />
                </CCard> -->
                  <CCol sm="12">
                    <CDataTable
                      :hover="hover"
                      :striped="striped"
                      :bordered="bordered"
                      :small="small"
                      :fixed="fixed"
                      :items="item.StudentSchedule"
                      :fields="scheduleStudent"
                      items-per-page-select
                      :items-per-page="small ? 5 : 10"
                      :dark="dark"
                      sorter
                      pagination
                    >
                      <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template>
                      <template #StudentInfo="{ item }">
                        <td>
                          <h6 style="color: #1e109c" class="text-uppercase">
                            {{ item.SubjectName }}
                          </h6>
                          <div>
                            <span class="custom-small text-muted"> Description :</span> <span class="custom-small-overview custom-text-overview">{{ item.Description }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Grade :</span> <span class="custom-small-overview custom-text-overview">{{ item.Grade }}</span>
                          </div>
                          <div>
                            <span class="custom-small text-muted"> Class Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.ClassName }}</span>
                          </div>
                        </td>
                      </template>
                      <template #Start="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.Start | moment("DD MMM YYYY HH:mm:ss")
                          }}</CBadge>
                        </td>
                      </template>
                      <template #End="{ item }">
                        <td>
                          <CBadge color="success" class="ml-auto">{{
                            item.End | moment("DD MMM YYYY HH:mm:ss")
                          }}</CBadge>
                        </td>
                      </template>
                    </CDataTable>
                    <!-- <vue-cal
                    class="vuecal--white-theme"
                    :events="feedData"
                    :time-from="7 * 60"
                    events-count-on-year-view="events-count-on-year-view"
                    events-on-month-view="short"
                    active-view="month"
                  >
                    <template v-slot:no-event="">No event 👌</template>
                  </vue-cal> -->
                  </CCol>
                </CCard>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </template>
      <br />
    </template>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import moment from "moment";

import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
//import "@fullcalendar/core/vdom"; // solves problem with Vite]
import VCalendar from "v-calendar";

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
Vue.use(FullCalendar);

export default {
  name: "Overview",
  components: {
    PulseLoader,
    moment,
    cSwitch,
    Calendar,
    VueCal,
  },
  props: ["manualstudentid", "invoiceid", "note"],
  data: function () {
    return {
      users: ["Students", "Teachers", "Parents"],
      collapse: false,
      attendance: false,
      quizs: false,
      subject: false,
      payment: false,
      schedule: false,
      parent: false,
      ViewSetPaymentModal: false,
      ViewAddPaymentModal: false,
      ViewPrintPaymentModal: false,
      ViewDeletePaymentModal: false,
      SelectedUser: "",
      SelectedParent: "",
      parents: [],
      SelectedStudent: "",
      students: [],
      studentDetails: {},
      feedData: [],
      detailByParent: {},

      eventCategories: [
        {
          id: 1,
          title: "Schedule",
          textColor: "white",
          backgroundColor: "red",
        },
      ],

      fields: [
        { key: "No" },
        { key: "SubjectName" },
        { key: "ClassInfo" },
        { key: "ScheduleDateTime" },
        { key: "Action" },
      ],
      quiz: [
        { key: "No" },
        { key: "SubjectName" },
        { key: "GradeName" },
        { key: "QuizInfo" },
        { key: "CreateTime" },
      ],
      paymentstudent: [
        { key: "No" },
        { key: "PaymentInfo" },
        { key: "InvoiceInfo" },
        { key: "BalanceDue" },
        { key: "ParentPaymentTime" },
        { key: "Action" },
      ],
      scheduleStudent: [
        { key: "No" },
        { key: "StudentInfo" },
        { key: "Teacher" },
        { key: "Start" },
        { key: "End" },
      ],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetAllParentsList();
      this.GetAllStudentsList();
      this.GetStudentDetails();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},
  methods: {
    async RefreshData() {
      //this.PaginationLoading = true;
      //this.CurrentPage = 1;
      //this.LastUserPerPageArray = {};
      await this.GetStudentDetails();
      await this.GetStudentDetailByParent();
      //this.PaginationLoading = false;
    },
    async GetAllParentsList() {
      this.$API
        .get(this.$AllParentList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },
    async GetAllStudentsList() {
      this.$API
        .get(this.$AllStudentList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    async GetStudentDetails() {
      this.$API
        .get(
          this.$StudentDetailByIdAuthorize + "?id=" + this.SelectedStudent.Id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentDetails = response.data;
          }
        });
    },
    async GetStudentDetailByParent() {
      this.$API
        .get(
          this.$StudentsDetailByParent +
            "?ParentEmail=" +
            this.SelectedParent.ParentEmail,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.detailByParent = response.data;
          }
        });
    },
    GotoPaymentPage(item) {
      let arr = this.studentDetails;
      //let routeData = this.$router.resolve({
        this.$router.push({
        path: "/TuitionPaymentStudent",
        params: {
          manualstudentid: arr.Id,
          invoiceid: item.InvoiceID,
          note: item.Month,
        },
      });
      //window.open(routeData.href, "_blank");
      console.log(arr.Id);
      console.log(item.InvoiceID);
      console.log(item.Month);
    },
    GotoPaymentPageByParent(item) {
      let arr = this.studentDetails;
      let routeData = this.$router.resolve({
        //this.$router.push({
        path: "/TuitionPaymentStudent",
        params: {
          manualstudentid: arr.Id,
          invoiceid: item.InvoiceID,
          note: item.Month,
        },
      });
      window.open(routeData.href, "_blank");
      console.log(arr.Id);
      console.log(item.InvoiceID);
      console.log(item.Month);
    },
    GotoAttendancePage(item) {
      let arr = this.studentDetails;
      let routeData = this.$router.resolve({
        //this.$router.push({
        path: "/TuitionAttendanceStudent",
        params: {
          manualstudentid: arr.Id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    GotoAttendancePageByParent(item) {
      let arr = this.studentDetails;
      let routeData = this.$router.resolve({
        //this.$router.push({
        path: "/TuitionAttendanceStudent",
        params: {
          manualstudentid: arr.Id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async GetPaymentStudentById() {
      this.$API
        .get(this.$AllParentList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },
    goToday() {
      this.$refs.calendar.goToday();
    },
  },
};
</script>
<style>
.custom-text-overview {
  color: #000000 !important;
}
.custom-small-overview {
  font-size: 90%;
  font-weight: 500;
}
.custom-small {
    font-size: 90%;
    font-weight: 500;
} 
</style>